import { Navigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { useRole } from '../../context/RoleContext'
import { Spinner } from './ui'

/**
 * Sends users to a sensible landing page based on role:
 *  - cashier -> POS sales screen
 *  - everyone else (admin / manager / unknown) -> Dashboard (the default)
 */
export default function HomeRedirect() {
  const { user, loading: authLoading } = useAuth()
  const { role, loading: roleLoading } = useRole()

  if (authLoading || roleLoading) return <Spinner label="Loading…" />
  if (!user) return <Navigate to="/login" replace />

  if (role === 'cashier') return <Navigate to="/sales" replace />
  return <Navigate to="/dashboard" replace />
}
